<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10">
        <path
            fill="#fff"
            d="M4 9V6H1c-.552285 0-1-.44772-1-1s.447715-1 1-1h3V1c0-.552285.44772-1 1-1s1 .447715 1 1v3h3c.55228 0 1 .44772 1 1s-.44772 1-1 1H6v3c0 .55228-.44772 1-1 1s-1-.44772-1-1"
        />
    </svg>
</template>
